// removed by extract-text-webpack-plugin
module.exports = {"root":"_3X95","paddingTop":"_2E6f","paddingBottom":"_16yV"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Layout/Container/Container.scss
// module id = oBzs
// module chunks = 0